import { useCallback } from 'react';
import _ from 'lodash';

export const SSN_UNIQUE_ERROR_MESSAGE = 'SSN must be unique';

interface UseSsnConflictErrorParams {
  setSsnConflictVisible: (visible: boolean) => void;
}

const useSsnConflictError = ({ setSsnConflictVisible }: UseSsnConflictErrorParams) =>
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  useCallback((error?: any) => {
    const message = _.get(error, 'response.data.elevate_error_message', '') || '';
    if (message.includes(SSN_UNIQUE_ERROR_MESSAGE)) {
      setSsnConflictVisible(true);
      return true;
    }
    return false;
  }, [setSsnConflictVisible]);

export default useSsnConflictError;
